export const statusTranslate = (status) => {
  const dictStatus =  {
    'waiting_supplier_company_input_vacancies_data': "Aguardando preenchimento dos dados dos plantões",
    'waiting_generate_doctor_contract': "Contrato disponivel para download",
    'waiting_doctor_sign_contract': "Aguardando assinatura do contrato pelo médico",
    'waiting_payment_doctor': "Aguardando realizar pagamento médico",
    'canceled': "Solicitação cancelada",
    'done': "Plantão Antecipado",
    'merged': "Agrupado (encerrado)",
    'expired': "Expirado (a empresa não analisou no prazo)",
  }

  // waiting_generate_doctor_contract: [waiting_supplier_company_input_vacancies_data, waiting_doctor_sign_contract]
  // waiting_doctor_sign_contract: [waiting_supplier_company_input_vacancies_data, waiting_generate_doctor_contract, waiting_payment_doctor]
  // waiting_payment_doctor: [waiting_supplier_company_callback]
  // waiting_supplier_company_callback: [done]

  
  return dictStatus[status] || status;
}

export const getListStatus = () => {
  return [
    'waiting_supplier_company_input_vacancies_data',
    'waiting_generate_doctor_contract',
    'waiting_doctor_sign_contract',
    'waiting_payment_doctor',
    'done',
    'canceled',
    // Por último: não é alcançável pelas setas do Trocar status (STATUS_TO_ASSIGN não o contém).
    'expired',
  ]
}

export const getAllBrasilStates = () => {
  return [
    { uf: "AC", name: "Acre - AC" },
    { uf: "AL", name: "Alagoas - AL" },
    { uf: "AP", name: "Amapá - AP" },
    { uf: "AM", name: "Amazonas - AM" },
    { uf: "BA", name: "Bahia - BA" },
    { uf: "CE", name: "Ceará - CE" },
    { uf: "DF", name: "Distrito Federal - DF" },
    { uf: "ES", name: "Espírito Santo - ES" },
    { uf: "GO", name: "Goías - GO" },
    { uf: "MA", name: "Maranhão - MA" },
    { uf: "MT", name: "Mato Grosso - MT" },
    { uf: "MS", name: "Mato Grosso do Sul - MS" },
    { uf: "MG", name: "Minas Gerais - MG" },
    { uf: "PA", name: "Pará - PA" },
    { uf: "PB", name: "Paraíba - PB" },
    { uf: "PR", name: "Paraná - PR" },
    { uf: "PE", name: "Pernambuco - PE" },
    { uf: "PI", name: "Piauí - PI" },
    { uf: "RJ", name: "Rio de Janeiro - RJ" },
    { uf: "RN", name: "Rio Grande do Norte - RN" },
    { uf: "RS", name: "Rio Grande do Sul - RS" },
    { uf: "RO", name: "Rondônia - RO" },
    { uf: "RR", name: "Roraíma - RR" },
    { uf: "SC", name: "Santa Catarina - SC" },
    { uf: "SP", name: "São Paulo - SP" },
    { uf: "SE", name: "Sergipe - SE" },
    { uf: "TO", name: "Tocantins - TO" },
  ];
}

export const isClosedStatus = (status) => ["done", "canceled", "merged", "expired"].includes(status);

// Filtros da lista do time interno na URL (AF-1/C7). Só os filtros que já existiam.
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
const isoOrEmpty = (value) => (ISO_DATE.test(value || "") ? value : "");

export const DEFAULT_ADVANCE_REQUEST_FILTERS = Object.freeze({
  doctorName: "",
  crm: "",
  crmUf: "",
  selectedStatus: [],
  startRequestDate: "",
  endRequestDate: "",
  includeInactive: false,
  // Conversão do ME (FE-C2): só aparece na barra com a chave registrationSeal.
  registrationPending: false,
});

export const parseAdvanceRequestSearch = (searchParams) => {
  const knownStatus = getListStatus();
  const uf = (searchParams.get("uf") || "").trim().toUpperCase();
  const [from = "", to = ""] = (searchParams.get("pedido") || "").split("..");
  const page = Number(searchParams.get("pagina"));
  return {
    filters: {
      doctorName: (searchParams.get("nome") || "").trim(),
      crm: (searchParams.get("crm") || "").trim(),
      crmUf: getAllBrasilStates().some((state) => state.uf === uf) ? uf : "",
      selectedStatus: (searchParams.get("status") || "")
        .split(",")
        .filter((slug) => knownStatus.includes(slug)),
      startRequestDate: isoOrEmpty(from),
      endRequestDate: isoOrEmpty(to),
      includeInactive: searchParams.get("inativas") === "1",
      registrationPending: searchParams.get("registro") === "pendente",
    },
    page: Number.isInteger(page) && page > 0 ? page : 1,
    order: searchParams.get("ordem") === "asc" ? "asc" : "desc",
  };
};

export const advanceRequestToSearch = ({ filters, page, order }) => {
  const p = new URLSearchParams();
  if (filters.doctorName) p.set("nome", filters.doctorName);
  if (filters.crm) p.set("crm", filters.crm);
  if (filters.crmUf) p.set("uf", filters.crmUf);
  if (filters.selectedStatus && filters.selectedStatus.length) p.set("status", filters.selectedStatus.join(","));
  if (filters.startRequestDate || filters.endRequestDate) {
    p.set("pedido", `${filters.startRequestDate || ""}..${filters.endRequestDate || ""}`);
  }
  if (filters.includeInactive) p.set("inativas", "1");
  if (filters.registrationPending) p.set("registro", "pendente");
  p.set("pagina", String(page));
  if (order === "asc") p.set("ordem", "asc");
  return p;
};
